import { Box } from "@jewlr/storybook/core"
import PropTypes from "prop-types"

import SliderItem from "areas/landing/elements/slider-item"
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselPrevious,
  CarouselNext,
} from "components/ui/carousel"
import { cn } from "styles/utils"

// Desktop slider will always be a slick slider
// If slider_type = "native" - mobile slider will be native scroll
const LandingSlider = ({ element, lazyload, slides }) => {
  const { className: itemClassName, ...itemProps } = element.item_style || {}

  return (
    <Box
      containWide
      {...element.style?.container_style}
      {...element.tabPanelProps}
    >
      <Box {...element.style?.slider_box_style}>
        <Carousel
          aria-label={element?.name || element.slider_settings?.frameAriaLabel}
          opts={{
            breakpoints: {
              "(min-width: 768px)": {
                dragFree: false,
              },
            },
            dragFree: true,
            slidesToScroll: "auto",
            ...element.slider_settings,
          }}
        >
          <CarouselContent>
            {slides.map((item, index) => (
              <CarouselItem
                className={cn(
                  "basis-(--base-basis) tablet:basis-(--tablet-basis)",
                  itemClassName
                )}
                key={`${element.id || element.anchor_name}-slide-${index}`}
                {...itemProps}
              >
                <SliderItem
                  element={element}
                  index={index}
                  item={item}
                  lazyload={
                    lazyload || (typeof lazyload === "undefined" && index > 3)
                  }
                />
              </CarouselItem>
            ))}
          </CarouselContent>
          <CarouselPrevious />
          <CarouselNext />
        </Carousel>
      </Box>
    </Box>
  )
}

LandingSlider.propTypes = {
  element: PropTypes.object,
  lazyload: PropTypes.bool,
  slides: PropTypes.array,
}

export default LandingSlider
